import { render, staticRenderFns } from "./CreateLogo.vue?vue&type=template&id=2efa6195&scoped=true"
import script from "./CreateLogo.vue?vue&type=script&lang=js"
export * from "./CreateLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa6195",
  null
  
)

export default component.exports